//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const baseURL = pageInfo.site_url+"/wp-json/wp/v2/";

  import axios from 'axios'
  import OperatorMap from './OperatorMap.vue'
  import { EventBus } from './event-bus'; // not really used atm, we're emitting events from this app, but no othercompoenents are listening for them (previously listened for by deleted overlay component)
  import ArticleListItem from "./ArticleListItem.vue";
  import SearchFilter from "./SearchFilter.vue";
  import iconListView from "./svg/svgList.vue";
  import iconMapView from "./svg/svgMap.vue";
  import BtnFavourites from './ButtonFavourites.vue'
  import mixins from './utilities.js'
  import pagination from './alphaPagination.js'
  import infiniteScroll from './infiniteScroll'

  /* eslint-disable no-unused-vars */
  import flatpickr from "flatpickr";
  import flatpickrStyles from "flatpickr/dist/flatpickr.min.css";
  /* eslint-enable no-unused-vars */

export default {
    name: 'Operators',
    props: {},
    mixins: [mixins, pagination, infiniteScroll],
    components: {
      OperatorMap,
      ArticleListItem,
      SearchFilter,
      iconListView,
      iconMapView,
      BtnFavourites
    },
    data: function () {
      return {
        displayAdvanced: true,
        locations: [],
        allCategories: [],
        allCategoriesString: '',
        categories: [],
        facilities: [],
        datePicker: '',
        displaySearchBtn: false,
        selectedCategory: [],
        selectedFacility: '',
        selectedLocation: '',
        selectedSubCategories: [],
        selectedPaginationItem: false,
        selectedSortOrder: "confirmation",
        isSortOrderReversed: false,
        displayInstantlyBookableOnly: false,
        operators: [],
        operatorUrls: [],
        keywords: '',
        itemsPerPage: 9,
        pageNumber: 1,
        postType: '',
        pagesTotal: 0,
        showLoadMore: false,
        isLoading: false,
        isNewSearch: true, // when "loading more" this is set to false
        restParamsString: '',
        queryString: '',
        isMapView: false,
        operatorListingType: null,
        operator_category: '',
        mapOperators: [],
        filterData: { keywords: "", category: "" }, //store data entered in filter before user presses submit, for when we dont want our list to auto filter
        filterDataDefaults: {
          'date': flatpickr.formatDate(new Date(), "Y-m-d"),
          'period': 1, // only used for accom
          'adults': 2,
          'children': 0,
          'infants': 0,
          'type': ''
        },
        filterDataSelected: {
          'date': flatpickr.formatDate(new Date(), "Y-m-d"),
          'period': 1, // only used for accom
          'adults': 2,
          'children': 0,
          'infants': 0,
        },
        bookEasy: {
          apiKey: '',
          vcId: '',
          listingType: 'accom' // used in bookeasy api queries
        },
        paginationItems: 'filteredDataAll', // variable name of items you are paginating
        showAll: true // don't enforce filter options for accomm
      }
    },
    watch: {
      filteredDataAllByPagination: function() {
        this.pagesTotal = Math.ceil(this.filteredDataAllByPagination.length/this.itemsPerPage);
        console.log('filterd data all cahneg total');
      },
      // hasMorePages() {
      //   if(!this.hasMorePages)
      //     this.removeInfiniteListener();
      // },
    },
    mounted: function () {

      console.warn("feed MOUNTED");
      let _this = this;

      this.getLocations();
      this.getCategories();

      let datePicker = document.getElementById("filter-date-picker");

      this.datePicker = flatpickr(datePicker, {
          //mode: "range",
          defaultDate: "today",
          altInput: true,
          altFormat: "d/m/Y", //format for display only
          //onChange: function(selectedDates, dateStr, instance) {
          onChange: function(selectedDates) {
            if(selectedDates.length>0) {
              if(flatpickr.formatDate(selectedDates[0], "Y-m-d") != _this.filterDataSelected.date){
                // _this.filterDataSelected.date= flatpickr.formatDate(selectedDates[0], "Y-m-d");
                _this.getPosts();
                //_this.updateUrl();
                _this.updateFilter('date', flatpickr.formatDate(selectedDates[0], "Y-m-d"));
              }
            }
          }
      });

      this.filterDataDefaults.date = flatpickr.formatDate(new Date(), "Y-m-d") // todays date as default

      if(this.filterDataSelected.date)
        this.datePicker.setDate( this.filterDataSelected.date);
      else
        this.filterDataSelected.date = this.filterDataDefaults.date

      this.filterDataDefaults.type = this.operatorListingType.slug;

    },
    created: function () {

      if(pageInfo.be){
        if(pageInfo.be.vc_id)
          this.bookEasy.vcId = pageInfo.be.vc_id;
        if(pageInfo.be.api_key)
          this.bookEasy.apiKey = pageInfo.be.api_key;
      }

      this.getPostsRequest = this.makeAJAXRequest();
      this.debounceKeywords = this.delay();

      //this.operatorListingType = pageInfo.operator_category.slug;

      this.operator_category = pageInfo.operator_category;
      this.operatorListingType = pageInfo.operator_listing_type;
      this.filterDataSelected.type = this.operatorListingType.slug;

      if(this.operatorListingType.slug !== 'accommodation')
        this.bookEasy.listingType = this.operatorListingType.slug;


      this.postType  = 'operator';


      if(pageInfo.operator_category.term_id != pageInfo.operator_listing_type.term_id) {//onload
        this.selectedCategory.push(pageInfo.operator_category.term_id);
        this.displayAdvanced = true;
      }

      else if(pageInfo.operator_category.name == 'Tours'){
        this.selectedCategory.push(pageInfo.operator_category.term_id);
      }


      /*
      const urlDate = decodeURI(this.getQueryVariable('date'));
      const urlAdults = parseInt(decodeURI(this.getQueryVariable('adults')));
      const urlChildren = parseInt(decodeURI(this.getQueryVariable('children')));
      const urlInfants = parseInt(decodeURI(this.getQueryVariable('infants')));
      const urlPeriod = parseInt(decodeURI(this.getQueryVariable('period')));

      if (isNaN(new Date(urlDate)) == false)
        this.filterDataSelected.date = urlDate;

      if (urlAdults && urlAdults < 46)
        this.filterDataSelected.adults = urlAdults

      if (urlChildren && urlChildren < 46)
        this.filterDataSelected.children = urlChildren

      if (urlInfants && urlInfants < 46)
        this.filterDataSelected.infants = urlInfants

      if (urlPeriod && urlPeriod < 31)
        this.filterDataSelected.period = urlPeriod
      */

     if(this.operatorListingType.name == 'Accommodation') {
       this.getBEFacilities()
     } else {
       this.getFacilities()
     }

      this.updateLocalStorage(null, null)

      window.onpopstate = function(event) {
        console.warn("location: " + document.location + ", state: " + JSON.stringify(event.state));
      };

      let _this = this;


      if(this.operatorListingType.slug == 'accommodation'){
        // get our operator urls first
        this.getPostsRequest(`${pageInfo.site_url}/wp-json/wisdom-operators/v1/operators?minimaldata=1&post_type=members&operator_type=${_this.operatorListingType.slug}`, {})
        .then(function(response){
          _this.operatorUrls = response.data;

          // then get the posts from bookeasy
          _this.getPosts();
        })

      } else { //  eg tours. Which are Wordpress AND Bookeasy
        _this.getPosts();
      }

    },
    methods: {
      getLocations(){

        let _this = this;

        if(this.operatorListingType.slug == 'accommodation') {

          axios
          //.get(baseURL + `operator_location?post_type=${_this.postType}`, {})
          .get(`https://webapi.bookeasy.com.au/api/getVcLocations?q=${_this.bookEasy.vcId}&key=${_this.bookEasy.apiKey}`, {})
          .then(function(response) {
            response.data.Locations.forEach(item => {
              _this.locations.push({
                value: item["LocationId"],
                label: item["Description"]
                //slug: item["slug"]
              });
            });
          })
          .catch(function(error) {
            console.error(error);
          });

        } else {
          axios
          .get(baseURL + `operator_location?post_type=${_this.postType}&per_page=100`, {})
          .then(function(response) {
            response.data.forEach(item => {
              _this.locations.push({
                value: item["id"],
                label: item["name"],
                slug: item["slug"]
              });
            });
          })
          .catch(function(error) {
            console.error(error);
          });
        }


      },
      getCategories(){
        let _this = this;


        let catQuery = `${pageInfo.site_url}/wp-json/wisdom-operators/v1/subcategories/${pageInfo.operator_listing_type.term_id}?hide_empty=1`

        axios.get(catQuery, {})
        .then(function(response) {
          response.data.forEach(item => {
            _this.categories.push({
              value: item["id"] ? item["id"] : item["term_id"],
              //value: _this.decodeEntities(item["name"]),
              label: item["name"],
              slug: item["slug"],
              term_id: item["id"] ? item["id"] : item["term_id"],
              parent: item["parent"]
            });
          });
        })
        .catch(function(error) {
          console.error(error);
        });

        /* below if from bookeasy */ /*
        axios
        .get(`https://webapi.bookeasy.com.au/api/get${_this.bookEasy.listingType}Attributes?q=${_this.bookEasy.vcId}&key=${_this.bookEasy.apiKey}`, {})
        .then(function(response) {
          response.data.Types.forEach(item => {
            _this.categories.push({
              value: item,
              label: item
              }
            );

          });
        })
        .catch(function(error) {
          console.error(error);
        });
        */
      },
      getBEFacilities(){
        let _this = this;

        let facilityQuery = `https://webapi.bookeasy.com.au/api/getAccomAttributes?q=${this.bookEasy.vcId}`

        _this.facilities = [] //reset

        axios.get(facilityQuery, {})
        .then(function(response) {
          response.data.Facilities.forEach((item, index) => {
            _this.facilities.push({
              value: index,
              label: item,
              slug: '',
              term_id: index,
            })
          })
        })
        .catch(function(error) {
          console.error(error);
        });
      },
      getFacilities(){
        let _this = this;

        _this.facilities = [] //reset

        let catQuery = `${pageInfo.site_url}/wp-json/wp/v2/operator_facilities?per_page=100`

        axios.get(catQuery, {})
        .then(function(response) {
          response.data.forEach(item => {
            _this.facilities.push({
              value: item["id"] ? item["id"] : item["term_id"],
              label: item["name"],
              slug: item["slug"],
              term_id: item["id"] ? item["id"] : item["term_id"],
            });
          });
        })
        .catch(function(error) {
          console.error(error);
        });
      },
      updateFacility(facility) {
        this.selectedFacility = facility;
        this.selectedPaginationItem = false; //reset

        if(this.operatorListingType.slug == 'tours') {
            this.getPosts();
        }
      },
      updateCategory($category) { // for single select category
        console.warn($category);
        if (!this.displaySearchBtn) {
          //this.category = $category; // automatically update the list
          this.selectedCategory = $category;
          this.selectedSubCategories = []; //reset
          this.selectedPaginationItem = false; //reset
          //this.displayAdvanced = false;
          this.getPosts();
        } else {
          this.filterData["category"] = $category; // save it for when user presses submit
        }
        this.updateUrl();
      },
      updateCategoryArray(category) {  // for multi select category
        console.warn(category);
        console.warn('lili');
        if (!this.displaySearchBtn) {

          const catIndex = this.selectedCategory.indexOf(category);
          if(catIndex == -1)
              this.selectedCategory.push(category);
          else
            this.selectedCategory.splice(catIndex, 1);

          //this.selectedSubCategories = []; //reset // no sub cats
          this.selectedPaginationItem = false; //reset
          //this.displayAdvanced = false;
          //this.getPosts();
          this.updateUrl();
        } else {
          //this.filterData["category"] = category; // save it for when user presses submit
        }

      },
      updateLocation($location) {
        if (!this.displaySearchBtn) {
          // automatically update the list
          this.selectedLocation = $location;
          this.selectedPaginationItem = false; //reset
          //this.displayAdvanced = false;

          if(this.operatorListingType.slug == 'tours') {
            this.getPosts();
          }

        } else {
          this.filterData["location"] = $location; // save it for when user presses submit
        }
        //this.updateUrl();
      },
      updateSubCategory(cat){
        const catIndex = this.selectedSubCategories.indexOf(cat.term_id);
        if(catIndex == -1)
            this.selectedSubCategories.push(cat.term_id);
        else
          this.selectedSubCategories.splice(catIndex, 1);

        this.selectedPaginationItem = false; //reset

        this.getPosts();
        this.updateUrl();
        //window.history.replaceState({"html":"lili","pageTitle":"response.pageTitle", "selectedCats": this.selectedSubCategories},"", "./lili"+cat.slug);
      },
      updatePaginationItem(item){
        if(this.selectedPaginationItem == item.label) {
          this.selectedPaginationItem = false; //toggle off if clicked on again
          this.pagesTotal = Math.ceil(this.operators.length/this.itemsPerPage);
        } else {
          this.selectedPaginationItem = item.label;
          this.pagesTotal = Math.ceil(item.count/this.itemsPerPage);
        }

        this.pageNumber = 1;

        const operatorsContainer = document.querySelector('.article-list__items, .operator-feed__map-container');
        setTimeout(function(){
          window.scrollTo({top: operatorsContainer.offsetTop-120, behavior: 'smooth'})
          console.log("SCROL NOW")
        }, 100);
      },
      resetFilter() {
        this.keywords = this.selectedLocation = "";
        this.selectedCategory = [];

        if(this.operatorListingType.slug == 'tours')
          this.selectedCategory.push(this.operatorListingType.term_id);

        this.selectedSubCategories = []; //reset
        this.selectedPaginationItem = false; //reset
        this.selectedFacility = ''; //reset
        this.filterDataSelected = this.filterDataDefaults;
        //this.filterDataSelected.date = flatpickr.formatDate(new Date(), "Y-m-d") // todays date as default
        this.datePicker.setDate( this.filterDataDefaults.date);
        this.resetLocalStorage();
        this.updateUrl();
        this.getPosts();
      },
      updateKeywords($keywords) {

        if (!this.displaySearchBtn) {
          this.keywords = $keywords; // automatically update the list
          this.selectedPaginationItem = false; //reset

          // this.debounceKeywords(function() {
          //   console.log("Time elapsed!!!!! get new data");
          //   this.getPosts();
          // }, 900);
        } else {
          this.filterData["keywords"] = $keywords; // save it for when user presses submit
        }
      },
      updateFilter(item, value) {
        if(item !== null && value !== null) {
          this.filterDataSelected[item] = value;
        }
        this.selectedPaginationItem = false; //reset
        //this.updateUrl();
        this.getPosts();
        this.updateLocalStorage(item, value)
      },
      toggleMapView() {
        this.isMapView = !this.isMapView
      //if(this.isMapView)
           // EventBus.$emit('update-operator-map'); //lili add
        //this.getOperators();

      },
      updateUrl(){

        let url = `${pageInfo.site_url}/${pageInfo.operator_listing_type.slug}/`

        if(this.selectedCategory) {
          const term = this.getCategoryById(this.selectedCategory[this.selectedCategory.length - 1]);

          if(term)
            url += term.slug+"/";

            //TODO this only adds 1 subcategory t url, what if multiple are selected, maybe we can add additional GET vars
        }

        // we don't need the below code now that this data is in local storage
        /*
        url += `?date=${this.filterDataSelected.date}&adults=${this.filterDataSelected.adults}&children=${this.filterDataSelected.children}&infants=${this.filterDataSelected.infants}`

        if (pageInfo.operator_listing_type.slug =='accommodation')
            url += `&period=${this.filterDataSelected.period}`

        */

        console.log('REPLACING URL HERE');
        window.history.replaceState({"html":"lili","selectedCats": this.selectedSubCategories},"", url); // todo, what data if any do we need to keep

        //todo add catgory to url
      },
      updateLocalStorage(item = null, value = null) {
        let filterData = JSON.parse(localStorage.getItem('wisdombeselectedfilter'))
        let today = new Date()

        if(filterData == null) {
          localStorage.setItem('wisdombeselectedfilter', JSON.stringify(this.filterDataSelected))
        } else {
          //if localstorage is not null and no user selection has been made set selected to localstorage data
          if(item === null && value === null) {
            this.filterDataSelected = filterData
          }

          let filterDate = new Date(filterData.date)
          let isPastDate = today > filterDate
          let monthInt = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']

          if(isPastDate) {
            this.filterDataSelected.date = `${today.getFullYear()}-${monthInt[today.getMonth()]}-${("0" + today.getDate()).slice(-2)}`
            filterData.date = `${today.getFullYear()}-${monthInt[today.getMonth()]}-${("0" + today.getDate()).slice(-2)}`
          }

          if(item == 'date') {
            this.filterDataSelected.date = value
          }

          //user selection has been made
          localStorage.setItem('wisdombeselectedfilter', JSON.stringify(this.filterDataSelected))
        }
      },
      resetLocalStorage() {
        localStorage.removeItem('wisdombeselectedfilter')
        localStorage.setItem('wisdombeselectedfilter', JSON.stringify(this.filterDataDefaults))
      },
      getCategoryById(termId) {
        console.warn('term = '+termId)
         const term =  this.categories.filter(item => {
            return termId == item.term_id
         });

         if(term)
            return term[0];
      },
      getPostsTours: function(isNewSearch = true) {
        console.warn("GETTINGPOSTSTOURS");
        var _this = this;

        this.noResults = false;

        this.queryString = ""; // if there is no category specified, if will get all post regardless of what category
        // if (this.postType === "posts" && pageInfo.news_cat_id)
        //   this.queryString = `&categories=${pageInfo.news_cat_id}`;

        //if (this.category != "") this.queryString = `&categories=${this.category}`;

        if (this.keywords != "") this.queryString += `&search=${this.keywords}`;

        if (this.dateRange && this.dateRange.length > 1) {
          let from = this.dateRange[0] + "T00:00:00.000Z";
          let to = this.dateRange[1] + "T23:59:59.000Z";

          this.queryString += `&after=${from}&before=${to}`;
        }

        if (this.selectedLocation !== '') this.queryString += `&operator_location=${this.selectedLocation}`;

        if (this.selectedFacility !== '') {
          let facilityId = this.facilities.filter(facility => {
            return facility.label == this.selectedFacility
          })[0].term_id
          this.queryString += `&operator_facilities=${facilityId}`;
        }

        //if(this.operatorListingType.slug != 'see-do')
          this.queryString += `&operator_type=${pageInfo.operator_listing_type.slug}`; // needed for tours & accomodation

        //if (this.operator_category.parent != 0 && pageInfo.operator_listing_type.term_id != this.operator_category.term_id ) this.queryString += `&operator_category=${this.selectedCategory}`

        if (this.selectedSubCategories.length > 0 )
          this.selectedSubCategories.forEach(item => { this.queryString +=  `&category[]=${item}`});
        else if (this.postType == 'deal' && this.selectedCategory.length > 0 )
          this.selectedCategory.forEach(item => { this.queryString +=  `&category[]=${item}`});
        else if (this.selectedCategory)
          this.selectedCategory.forEach(item => {
            this.queryString += `&category[]=${item}`;
          });

        this.queryString += `&category_taxonomy=${this.operatorListingType.taxonomy}`;

        console.warn(`query string = ${this.queryString}`);

        if (isNewSearch){
          this.pageNumber = 1;//reset
          this.isNewSearch = true;
        } else {
          this.pageNumber++; // ie we are 'loading more'
          this.isNewSearch = false;
        }

        //this.getPostsRequest(baseURL + _this.postType + `?per_page=${this.itemsPerPage}&page=${this.pageNumber}${this.queryString}`, isNewSearch)
        this.getPostsRequest(`${pageInfo.site_url}/wp-json/wisdom-operators/v1/operators?exclude_nocoords=0&post_type=${this.postType}${_this.queryString}`, {})

        .then(function(response){

          if(response) { // check incase request was previously cancelled is wont produce results

            _this.getPostsRequest(`https://webapi.bookeasy.com.au/be/get${_this.bookEasy.listingType}RatesGrid?q=${_this.bookEasy.vcId}&date=${_this.filterDataSelected.date}&period=${_this.filterDataSelected.period}&adults=${_this.filterDataSelected.adults}&children=${_this.filterDataSelected.children}&infants=${_this.filterDataSelected.infants}&enforceBookingConditions=false&key=${_this.bookEasy.apiKey}&enforceEntirePeriod=false`, {})

            .then(function(beResponse){

              let newPosts = response.data;

              newPosts.forEach(item => {
                if(_this.postType == 'deal') // dont' display any of the operator contact detail on the Deals list
                  item.operator_data["phone"] = item.operator_data["address"] = item.operator_data["email"] = item.operator_data["website"] = item.operator_data['is_proud_member'] = false;

                if(!item.operator_data.display_page & _this.postType != 'deal' ){
                  // non member don't have full pages ie a link
                  item["fimg"] = false; // they don't have custom images (incase there is already one set)
                  item["url"] = false;
                }
              });

              if (isNewSearch)
                _this.operators = newPosts; // replace all old posts with new results
              else
                _this.operators.push(...newPosts); // we are 'loading more': append new results

              _this.pagesTotal = Math.ceil(response.data.length/_this.itemsPerPage);


              if (response.data.length < 1)
                _this.noResults = true


              /********************* */


              if(beResponse) { // check incase request was previously cancelled is wont produce results
                console.warn(beResponse);

                beResponse.data.forEach(item => {

                    let operator_data = {};

                    operator_data.has_hot_deals = false;

                    item.Items.forEach( operatorProduct => {
                        if(operatorProduct.Availability.Specials.length>0)
                          operatorProduct.Availability.Specials.forEach( special => {
                            if(special.IsHotDeal)
                              operator_data.has_hot_deals=true;
                          });
                    })

                    operator_data.items = item.Items;
                    operator_data.is_gold_medal = item.IsGoldMedal;

                    for (let i =0; i < _this.operators.length; i++) {
                      if (item.OperatorId === _this.operators[i].operator_data.be_id) {
                        let wp = _this.operators[i].operator_data;
                        _this.operators[i].operator_data = {...wp , ...operator_data};
                        //console.log("lilites", operator_data );
                        break;
                      }
                    }


                });


                EventBus.$emit('update-operator-map')

              }
            });

          }
        });
      },
      getPosts: function(isNewSearch = true) {

        if(this.operatorListingType.slug !== 'accommodation') {
          this.getPostsTours(isNewSearch);
          return;
        }

        console.warn("GETTINGPOSTS");

        var _this = this;

        this.queryString = ""; // if there is no category specified, if will get all post regardless of what category

        if (this.keywords != "") this.queryString += `&search=${this.keywords}`;

        if (this.dateRange && this.dateRange.length > 1) {
          let from = this.dateRange[0] + "T00:00:00.000Z";
          let to = this.dateRange[1] + "T23:59:59.000Z";

          this.queryString += `&after=${from}&before=${to}`;
        }

        if (this.selectedLocation !== '') this.queryString += `&operator_location=${this.selectedLocation}`;

        //if(this.operatorListingType.slug != 'see-do')
 ////         this.queryString += `&operator_type=${pageInfo.operator_listing_type.slug}`; // needed for tours & accomodation

/*
        if (this.selectedSubCategories.length > 0 )
          this.selectedSubCategories.forEach(item => { this.queryString +=  `&operator_category[]=${item}`});
        else if (this.selectedCategory != "" )
          this.queryString += `&operator_category[]=${this.selectedCategory}`;
   */

        console.warn(`query string = ${this.queryString}`);

        if (isNewSearch){
          this.pageNumber = 1;//reset
          this.isNewSearch = true;
        } else {
          this.pageNumber++; // ie we are 'loading more'
          this.isNewSearch = false;
        }

        this.getPostsRequest(`https://webapi.bookeasy.com.au/be/get${this.bookEasy.listingType}RatesGrid?q=${_this.bookEasy.vcId}&date=${_this.filterDataSelected.date}&period=${_this.filterDataSelected.period}&adults=${_this.filterDataSelected.adults}&children=${_this.filterDataSelected.children}&infants=${_this.filterDataSelected.infants}&enforceBookingConditions=false&key=${_this.bookEasy.apiKey}&enforceEntirePeriod=false`, {})

        .then(function(response){
          if(response) { // check incase request was previously cancelled is wont produce results
            console.warn(response);

            let newPosts = [];

            response.data.forEach(item => {

                let beItem = {}

                beItem.title = { 'rendered' : item.OperatorName }
                beItem.description = item.Description
                beItem.url = false // todo need to get permalink and then append # Bookeasy ID

                if(item.PrimaryImage)
                    beItem.fimg = item.PrimaryImage.FullSizeImage; // ThumbnailImage too small
                else if(item.OtherImages && item.OtherImages[0])
                    beItem.fimg = item.OtherImages[0].FullSizeImage;
                else
                    beItem.fimg = false;

                let operator_data = {};

                operator_data.is_proud_member = true; //assume all bookeasy are members
                //operator_data.phone = false //don't need
                operator_data.address = item.Address
                //operator_data.email = false //don't need
                //operator_data.website = false //don't need
                operator_data.latitude = item.Latitude
                operator_data.longitude = item.Longitude
                //operator_data.price_from = false;
                operator_data.has_hot_deals = false;
                operator_data.be_id = item.OperatorId;

                //let prices = [];
                item.Items.forEach( operatorProduct => {
                    // if(operatorProduct.Availability.IsAvailable)
                    //     prices.push(operatorProduct.Availability.Cost);

                    if(operatorProduct.Availability.Specials.length>0)
                      operatorProduct.Availability.Specials.forEach( special => {
                        if(special.IsHotDeal)
                          operator_data.has_hot_deals=true;
                      });
                })

                // prices.sort((a,b) => { return a-b }); // sort lowest price first

                // if(prices.length > 0)
                //     operator_data.price_from = prices[0]; // display the lowest price in the list view

                operator_data.items = item.Items;
                operator_data.is_gold_medal = item.IsGoldMedal;

                beItem.operator_data = operator_data;

                /* for filtering */
                beItem.locations = item.Locations;
                beItem.location = item.Location;
                beItem.categories = item.TypeGrouping;
                beItem.facilities=item.Facilities;

                // get url from our list
                //let urlData = _this.operatorUrls.some( element => { return element.OperatorId == item.be_id });

                for (let i =0; i < _this.operatorUrls.length; i++) {
                  if (item.OperatorId === _this.operatorUrls[i]['be_id']) {
                    beItem.id = _this.operatorUrls[i].id;
                    beItem.url = _this.operatorUrls[i].url;
                    beItem.operator_data = {...beItem.operator_data, ..._this.operatorUrls[i].operator_data};
                    break;
                  }
                }

                if(beItem.url)
                  newPosts.push(beItem);
                else
                  console.warn("missing from wp urls", beItem)


            //   if(!item.operator_data.is_proud_member){
            //       // non member don't have full pages ie a link
            //       item["fimg"] = false; // they don't have custom images (incase there is already one set)
            //       item["url"] = false;
            //   }

            });

            if (isNewSearch)
              _this.operators = newPosts; // replace all old posts with new results
            else
              _this.operators.push(...newPosts); // we are 'loading more': append new results

            _this.pagesTotal = Math.ceil(response.data.length/_this.itemsPerPage);

            //if(_this.isMapView)
              EventBus.$emit('update-operator-map')
          }
        });
      },
      loadMorePosts() {
        this.getPosts(false);
      },
      displayMorePosts() {
        this.pageNumber++;
      },
      subCategoriesClass(id, arrayName = 'selectedSubCategories'){
        let cssClass=[];

        cssClass.push("subcategory-btn");

        if(this[arrayName].includes(id))
            cssClass.push("is-selected");

        return cssClass;
      },
      appClasses() {
        let cssClass=[];

        cssClass.push("article-list");

        if(this.isLoading)
            cssClass.push("is-loading");

        if(this.isLoading && this.isNewSearch)
            cssClass.push("is-new-search");

        return cssClass;
      },
      getFromPrice(operatorData){

        if((!operatorData.be_id || !operatorData.items)) // && this.operatorListingType.slug == 'tours')
          return false;

        let prices = [];
        operatorData.items.forEach( operatorProduct => {

            if(this.operatorListingType.slug == 'accommodation') {
              if(operatorProduct.Availability.IsAvailable && ((operatorProduct.MaxNumberOfGuests >= this.selectedGuestsTotal && !operatorProduct.Availability.IsConstrained) || (operatorProduct.MaxNumberOfGuests >= this.selectedGuestsTotalUnconstrained && !operatorProduct.Availability.IsConstrained)))
                  prices.push(operatorProduct.Availability.Cost);
            }else{
              if(operatorProduct.Availability.IsAvailable)
                  prices.push(operatorProduct.Availability.Cost);
            }
        });

        prices.sort((a,b) => { return a-b }); // sort lowest price first

        if(prices.length > 0)
            return Math.ceil(prices[0]); // display the lowest price in the list view and round up to nearest dollar

        return false;
      }
    },
    computed: {
      mainCategories() { // first level of categories (ie the ones under see-do, tours, accomm). Don't ever change.
        return this.categories.filter(item => {
          if (pageInfo.operator_listing_type.term_id == item.parent)
            return true;
        });
      },
      subCategories() { // second level of categories, ie children of the mainCategories. Changes when selectedCategory (in MainCategories) changes
        return this.categories.filter(item => {
          if (this.selectedCategory == item.parent)
            // display all (if no category selected)
            return true;

        });
      },
      filteredData() { /* Displayed list of operator */
        return this.filteredDataAllByPagination.slice(0, this.pageNumber * this.itemsPerPage)
      },
      filteredDataAll() { /* Same as filteredData but returns ALL AND DOES NOT include pagination (used for generating the pagination links) */

        var words = this.keywords.split(" ").filter( word =>  word !== '' );
        console.warn(`searching`, words);

        let sortedData = this.operators
        .filter( item => { // filter by Location
          if(this.operatorListingType.slug == 'tours') return true; // tours are already filtered by location

          if(!this.selectedLocation)
              return true;

          return item.locations.some( location => { return location.LocationId == this.selectedLocation });

        })
        .filter( item => { // filter by facility
          if(this.operatorListingType.slug == 'tours') return true; // tours are already filtered by facilities

          if(!this.selectedFacility) return true;

          if(item.facilities)
            return item.facilities.some( facility => { return facility.FacilityName == this.selectedFacility });

          return false
        })
        .filter( item => { // filter by Category
          if(this.operatorListingType.slug == 'tours') return true; // tours

          if(this.selectedCategory.length < 1)
              return true;

          return item.categories.some( type => { return this.selectedCategoryNames.includes(type) });

        }).filter( item => { /* filter by keywords */

          // what text are we searching through?
          let searchString = `${item.title.rendered} ${item.operator_data.address} ${item.description}`;

          return words.every( word => { return searchString.toLowerCase().match(word.toLowerCase()) })

        }).filter( item => { /* filter by Guests */

          if(this.operatorListingType.slug == 'accommodation' && this.showAll == false){
            return item.operator_data.items.some(operatorProduct => { return (operatorProduct.MaxNumberOfGuests >= this.selectedGuestsTotal && !operatorProduct.Availability.IsConstrained) || (operatorProduct.MaxNumberOfGuests >= this.selectedGuestsTotalUnconstrained && !operatorProduct.Availability.IsConstrained) });
          }else{
            return true;
          }

        }).filter( item => { /* filter by Instantly Bookable only */

          if(this.displayInstantlyBookableOnly && !item.operator_data.be_id)
            return false;

          return this.displayInstantlyBookableOnly ? item.operator_data.is_gold_medal && this.getFromPrice(item.operator_data) : true;

        }).sort((a,b) => {

          if(this.selectedSortOrder == 'name') {
            if (a.title.rendered == b.title.rendered)
              return 0;
            else
              return a.title.rendered < b.title.rendered ? -1 : 1;
          }else if(this.selectedSortOrder == 'price') {

            if(!this.getFromPrice(a.operator_data)) // if no price at all, move to bottom
              return 1;

            else if (!this.getFromPrice(b.operator_data)) // if no price at all, move to bottom
              return -1;

            else
              return this.getFromPrice(a.operator_data) - this.getFromPrice(b.operator_data);

          } else if (this.selectedSortOrder == "confirmation") {
            if (!this.getFromPrice(a.operator_data))
              // if no price at all, move to bottom
              return 1;
            else if (!this.getFromPrice(b.operator_data))
              // if no price at all, move to bottom
              return -1;
            else if (
              a.operator_data.is_gold_medal &&
              b.operator_data.is_gold_medal
            )
              return (
                this.getFromPrice(a.operator_data) -
                this.getFromPrice(b.operator_data)
              );
            else if (a.operator_data.is_gold_medal) return -1;
            else if (b.operator_data.is_gold_medal) return 1;
            // no instant bookables, so just compare price
            else
              return (
                this.getFromPrice(a.operator_data) -
                this.getFromPrice(b.operator_data)
              );

          }else if(this.selectedSortOrder == 'deals') {

            if (a.operator_data.has_hot_deals == b.operator_data.has_hot_deals)
              return 0;
            else
              return a.operator_data.has_hot_deals < b.operator_data.has_hot_deals ? 1 : -1;
          }else if(this.selectedSortOrder == 'location') {
            if (a.location == b.location)
              return 0;
            else
              return a.location < b.location ? -1 : 1;
          }

        });

        if(this.isSortOrderReversed)
          sortedData.reverse();

        return sortedData;

      },
      filteredDataAllByPagination() { /* Same as filteredDataAll but also filters by pagination */

        return this.filteredDataAll.filter(item => { /* filter by pagination character */

          if(!this.selectedPaginationItem)
            return true;

          if(this.selectedPaginationItem == item.paginationKey)
            return true;
        });
      },
      filteredDataAllWithMarkers () {
        return this.filteredDataAll.filter( (item) => {
          if(item.operator_data.latitude)
            return true;
          }
        );
      },
      selectedCategoryNames(){

          if(this.operatorListingType.slug == 'tours') return false // not needed for tours (only accom)

          let $cats = [];

          this.selectedCategory.forEach(id => {
            let term = this.getCategoryById(id);
            console.warn('lili', term);
            $cats.push(this.decodeEntities(term.label));
          });

          return $cats;
      },
      selectedGuestsTotal(){
        return parseFloat(this.filterDataSelected.adults) + parseFloat(this.filterDataSelected.children) + parseFloat(this.filterDataSelected.infants);
      },
      selectedGuestsTotalUnconstrained(){
        return parseFloat(this.filterDataSelected.adults) + parseFloat(this.filterDataSelected.children);
      },
      // hasMorePages() {
      //   return this.pagesTotal > this.pageNumber
      // }
    }
  }






// WEBPACK FOOTER //
// ./scripts/vue/BookEasyFeed.vue